<template>
    <div class="div">
        <button class="button is-small" :class="{'bold' : isFilled }" @click="openModal" style="width: 55px;">
            {{ car.insurance_date ? formatDate(car.insurance_date) : '---' }}
        </button>
        <div class="modal" :class="{'is-active': isActive }">
            <div class="modal-background" @click="isActive = !isActive"></div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">Insurance: {{ car.insurance }}</p>
                    <button class="delete" aria-label="close" @click="isActive = !isActive"></button>
                </header>
                <section class="modal-card-body">
                    <table class="is-fullwidth table is-bordered is-striped">
                        <thead>
                        <tr>
                            <th width="10">Select</th>
                            <th>Name</th>
                            <th>Info</th>
                            <th>Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(company, index) in insurances">
                            <td width="10">
                                <button class="button is-info" @click="selectCompany(company.name)">
                                        <span class="icon">
                                          <i class="fas fa-check"></i>
                                        </span>
                                </button>
                            </td>
                            <td class="subtitle">{{ company.name }}</td>
                            <td>{{ company.info }}</td>
                            <td width="10">
                                <button class="button is-danger" @click="deleteCompany(index, company)">
                                        <span class="icon">
                                          <i class="fas fa-trash"></i>
                                        </span>
                                </button>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2">
                                <input v-model="newInsurance.name" class="input" type="text" placeholder="Type name of the insurance company">
                            </td>
                            <td>
                                <input v-model="newInsurance.info" class="input" type="text" placeholder="Insurance type info">
                            </td>
                            <td width="10">
                                <button class="button is-primary" @click="createNewCompany">
                                    <span class="icon">
                                        <i class="fas fa-save"></i>
                                    </span>
                                </button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <div class="field is-horizontal">
                        <div class="field-body">
                            <div class="field">
                                <datetime
                                        input-class="input"
                                        v-model="carData.query.insurance_date"
                                        :format="{ month: 'numeric', day: 'numeric'}"
                                        type="date"
                                        value-zone="local"
                                        zone="local"
                                        :input-id="carData.id.toString()"
                                        placeholder="Select date"
                                ></datetime>
                            </div>
                        </div>
                    </div>
                </section>
                <footer class="modal-card-foot">
                    <button class="button"  @click="isActive = !isActive">Close</button>
                    <button class="button is-primary"  @click="saveChanges">Save</button>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
    import apiCars from './../../../api/apiCars'
    import apiInsurance from './../../../api/apiInsurance'
    import { Datetime } from 'vue-datetime'
    import 'vue-datetime/dist/vue-datetime.css'
    import moment from 'moment'
    export default {
        props:['car'],
        components: {
            Datetime
        },
        data () {
            return {
                isActive: false,
                insurances: [],
                carData:{
                    id: this.car.id,
                    query: {
                        insurance_date: this.car.insurance_date,
                        insurance: this.car.insurance,
                    }
                },
                newInsurance: {
                    name: '',
                    info: ''
                }
            }
        },
        computed: {
            isFilled() {
                if (this.formatDate(this.carData.query.insurance_date) !== '---'){
                    return  true;
                }
            }
        },
        methods: {
            createNewCompany(){
                apiInsurance
                    .createInsuranceRequest(this.newInsurance)
                    .then((response) => {
                        this.insurances.push(response.data)
                        this.newInsurance.name = ''
                        this.newInsurance.info = ''
                    })
                    .catch(error => console.log(error))
            },
            selectCompany(name) {
                this.carData.query.insurance = name
                apiCars
                    .updateCarRequest(this.carData)
                    .then((response) => {
                        this.car.insurance = this.carData.query.insurance
                    })
                    .catch(error => console.log(error))
            },
            deleteCompany(index, port){
                apiInsurance
                    .deleteInsuranceRequest(port.id)
                    .then((response) => {
                        this.insurances = this.insurances.filter(item => item !== port)
                    })
                    .catch(error => console.log(error))
            },
            formatDate(date) {

                if(date){
                    return moment(date).format('M/D')
                }else{
                    return '---'
                }
            },
            openModal() {
                this.isActive = !this.isActive
                apiInsurance
                    .insurancesListRequest()
                    .then((response) => {
                        this.insurances = response.data
                    })
                    .catch(error => console.log(error))
            },
            saveChanges() {
                apiCars
                    .updateCarRequest(this.carData)
                    .then((response) => {
                        this.car.insurance_date = this.carData.query.insurance_date
                        this.car.insurance = this.carData.query.insurance
                        this.isActive = false
                    })
                    .catch(error => console.log(error))
            }

        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Cars/Columns/InsuranceColumn.vue